<template>
    <div class="container-fluid" v-if="school">
        <div class="row justify-content-between">
            <div class="col">
                <h4>{{school.name}}> Хичээлүүд </h4>
            </div>
        </div>
        <div class="card shadow my-4">
            <div class="card-body">
                <div class="table-responsive mt-3">
                    <table class="table table-sm table-bordered" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Хичээл</th>
                                <th>Төрөл</th>
                                <th>Ангиар/Группээр</th>
                                <th>Үйлдэл</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(lesson, index) in lessons">
                                <td>
                                    {{index+1}}.  
                                    {{lesson.name}}, {{lesson.id}}
                                    <span class="font-weight-bold" v-if="lesson.classNos && lesson.classNos.length>0">  /{{lesson.classNos[0]}} анги/</span>
                                    <span class="ml-5 badge badge-success" v-if="lesson.typeDetail">
                                        {{lesson.typeDetail.name}}
                                    </span>
                                    <ul v-if="lesson.groups && lesson.groups.length>0">
                                        <li class="text-primary" style="cursor:pointer" v-for="(group,index) in lesson.groups" @click="$router.push({ name: 'IGroupStudents', params: { schoolId: schoolId, departmentId: group.department.id, programId: group.program.id} })">
                                            <span v-if="group.departmentName">{{group.departmentName}}</span>
                                            <span v-else>-</span>
                                            <span class="text-uppercase text-primary" v-if="group.programName">{{group.programName}}</span>
                                            <span v-else>-</span>
                                            <span v-if="index<lesson.groups.length-1">, </span>
                                            
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    {{lesson.categoryTypeName}}, {{lesson.categoryTypeId}}
                                    <!-- <span class="badge badge-success" v-if="category.typeDetail.id=='zaaval'">{{category.typeDetail.name}}</span>
                                    <span class="badge badge-warning" v-else>{{category.typeDetail.name}}</span> -->
                                </td>
                                <td>
                                   <span v-if="lesson.isGroup" class="badge badge-danger">группээр</span>
                                   <span v-else class="badge badge-primary">ангиар</span>     
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-info" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-grow text-dark" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../../firebaseConfig.js')

    export default {
        name:'ListOfLessons',
        data() {
            return {
        
               loading:false,
               school:null,
               categories:[],
               lessons:[]
            }
        },
        props: {
            schoolId: { 
                required: true,
            },
        },
        computed: {
            ...mapState(['userProfile', 'currentUser']) 
        },
        methods: {
      
            async _getSchool(schoolId){
                var schoolDoc=await fb.db.doc('schools/'+schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school;
                    await this.getLessonsData(schoolId);
                }
                this.loading=false;
            },
            async _findCategory(lesson){
                console.log('1. reading', lesson.category.id);
                var catRef = fb.db.collection("schools/"+this.schoolId+"/categories").doc(lesson.category.id);
                await catRef.get().then(function(doc) {
                    lesson.categoryTypeId = doc.data().typeDetail.id;
                    lesson.categoryTypeName = doc.data().typeDetail.name;
                }).catch(function(error) {
                    console.log("Error getting cached document:", error);
                });
            },
            async getLessonsData(schoolId){
                    var query;
                    query=fb.db.collection("schools/"+schoolId+"/lessons").where("teacher", "==", this.userProfile.customer);
                    
                    if(query!=null){
                        var lessonsDatas=await query.get();
                        for(const doc of lessonsDatas.docs){
                            let lesson=doc.data()
                            lesson.id = doc.id;
                            lesson.procent=0;
                            if(lesson.category && lesson.category.id){
                                await this._findCategory(lesson);
                                this.lessons.push(lesson);
                            }
                        }
                    }
                    this.loading=false;
            },
  
        },
        created() {
           this._getSchool(this.schoolId);
        },
 
    }
</script>
